import React from "react";
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import Config from "../../../config";
import {Button, Card, CardContent, Typography} from "@material-ui/core";
import Formsy from "formsy-react";
import classNames from 'classnames';
import {TextFieldFormsy, FuseAnimate} from '@fuse';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from "../common/EndpointsGetter";
import history from "../../../history";
import {Modal} from 'react-bootstrap';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class ForgotPassword extends React.Component {

    state = {
        error: null,
        canSubmit: false,
        show: false,
        modalMessage: ''
    };

    sendMail(user) {
        this.disableButton();
        let qs = require('qs');
        let username = user.username;
        axiosInstance.get(EndpointsGetter.getSendMailForgotPasswordEndpoint() + '/' + username)
            .then(response => {
                let oldState = {...this.state};
                if (response.status == 200) {
                    oldState.modalMessage = 'Link for resetting a password was sent to ' + username + '. Please, check your mail.';
                } else {
                    oldState.modalMessage = 'Sending failed! Please contact Kanin Support.';
                }
                oldState.show = true;
                oldState.canSubmit = true;
                this.setState(oldState);
            })
            .catch(error => {
                this.setState({error: error.response.data.message, canSubmit: true})
            });
    }


    disableButton = () => {
        this.setState({canSubmit: false});
    };

    enableButton = () => {
        this.setState({canSubmit: true});
    };

    handleHideModal() {
        this.state.show = false;
        this.forceUpdate();
    }

    render() {
        const {classes} = this.props;

        return(
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 sm:flex-col md:flex-col md:p-0")}>

                <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>

                    <div className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>
                        <FuseAnimate animation="transition.expandIn">
                            <img className="w-512 mb-32" src="assets/images/logos/kanin_h.png" alt="logo"/>
                        </FuseAnimate>

                        <div className={"hidden-sm hidden-xs"} style={{color:'white', 'bottom': '1%', 'left': '1%', 'position': 'absolute', 'font-size': '1.5vh'}}>
                            <div style={{'textAlign':'left'}}>v.{Config.versionNumber} #{Config.buildVersion}</div>
                            {Config.company}
                        </div>
                    </div>

                    <FuseAnimate animation={{translateX: [0, '100%']}}>

                        <Card className={classNames(classes.card, "mx-auto m-16 md:m-0")}>

                            <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">

                                <Typography variant="title" className="md:w-full mb-32">FORGOT PASSWORD</Typography>

                                <Formsy
                                    onValidSubmit={(model) => this.sendMail(model)}
                                    onValid={this.enableButton}
                                    onInvalid={this.disableButton}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center w-full"
                                >
                                    <div style={{color: 'red', marginBottom: 5}}>
                                        {this.state.error != null ? this.state.error : null}
                                    </div>
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="username"
                                        label="Username/Email"
                                        validations={{
                                            minLength: 1,
                                            isEmail: true
                                        }}
                                        validationErrors={{
                                            minLength: 'Username cannot be empty',
                                            isEmail: 'This is not a valid email'
                                        }}
                                        required              
                                    />

                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case"
                                        aria-label="SEND RECOVERY LINK"
                                        disabled={!this.state.canSubmit}
                                        value="legacy"
                                    >
                                        Send recovery link                                            
                                    </Button>
                                </Formsy>
                                <Button
                                    href="/login"
                                    variant="raised"
                                    className="w-full mx-auto mt-16 normal-case"
                                    aria-label="BACK"
                                    value="legacy"
                                >
                                    Back to Login
                                </Button>
                            </CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
                <div className={"hidden-md hidden-lg hidden-xl"} style={{color:'white', 'bottom': '1%', 'left': '1%', 'font-size': '1.5vh'}}>
                    v.{Config.versionNumber} #{Config.buildVersion}<br/>
                    {Config.company}
                </div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title">
                            Message
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalMessage}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-info"
                                onClick={(e) => this.handleHideModal()}>
                            OK
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(ForgotPassword));


// WEBPACK FOOTER //
// ./src/main/content/forgot-password/ForgotPassword.js